import type {GtmPlugin, TrackEventOptions} from '@gtm-support/vue-gtm';
import type {Ref} from 'vue';
import {useGtm} from '@gtm-support/vue-gtm';
import {useProposition} from '@myparcel-frontend/proposition';
import {ref} from 'vue';
import {useEnvironmentStore} from '@/env/useEnvironmentStore';

const gtm = ref<GtmPlugin>();

interface UseGtm {
  gtm: Ref<GtmPlugin | undefined>;
  loadGtm: () => void;
  trackEvent: (event: TrackEventOptions) => void;
}

export default function useGoogleTagManager(): UseGtm {
  const {proposition} = useProposition();
  const {environment} = useEnvironmentStore();

  const loadGtm = () => {
    gtm.value = useGtm() as GtmPlugin;
  };

  /**
   * Push any event to Google Tag Manager.
   */
  const trackEvent = (event: TrackEventOptions) => {
    if (environment.devMode) {
      console.warn(`GTM event: ${event}. was not sent to GTM because of devMode`);
      return;
    }

    if (!proposition.value.tools.googleTagManager.enabled || !proposition.value.tools.googleTagManager.id) {
      return;
    }

    gtm.value?.trackEvent(event);
  };

  return {
    gtm,
    loadGtm,
    trackEvent,
  };
}
